import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/settings/security` — прежний адрес второго фактора. Теперь он никуда не ведёт сам, а приводит
 * на `/profile`.
 *
 * Второй фактор переехал на страницу профиля вместе с STORY-043-05: у человека появилось одно
 * место, где он настраивает себя, — и держать «Безопасность» отдельным разделом значило бы иметь
 * **два места с одним содержимым**. Разъезжаются такие пары молча: правка приезжает в одно из них,
 * а половина людей ходит в другое.
 *
 * **Редирект, а не удаление маршрута.** Адрес прожил в продукте несколько эпиков: он в закладках, в
 * переписке и в собственных докстрингах этого репозитория. Снятый маршрут ответил бы «страница не
 * найдена» — то есть сказал бы, что второго фактора больше нет, что неправда.
 *
 * В `beforeLoad`, а не в компоненте: гард выполняется **до** загрузки и рендера, поэтому вкладка
 * никогда не показывает промежуточный экран и не тратит запрос на страницу, которую тут же
 * покидает. `replace: true` — чтобы «назад» из профиля возвращало туда, откуда человек пришёл, а не
 * на редирект, который снова его сюда приведёт.
 *
 * Пункта меню на этот адрес больше нет (`widgets/app-shell/model/nav-sections.constant.ts`): пункт,
 * ведущий на редирект, — это тот же второй адрес, только в интерфейсе.
 */
export const Route = createFileRoute('/_authenticated/settings/security')({
  beforeLoad: () => {
    throw redirect({ to: '/profile', replace: true });
  },
});
